import { useApiMutationWithToken } from "../useGeneralMutation";

export const useLogout = () => useApiMutationWithToken<{ pinfl?: number | string; phone?: number | string }>("/auth/logout", "post");
